import { useState } from 'react';
import React from 'react';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from "react-i18next";
import { Image } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { CHANGE_LANGUAGE } from '@reduxLocal/actions/types';
import {SL, GB, DE, ES, GR, JP, TR, AR, CN, IT, UAE } from "@assets/--native/index";
import { View, Text } from 'react-native';
import FlagHandler from './FlagHandler';
import { DefaultRootState } from '@reduxLocal/persistState';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
// ----------------------------------------------------------------------

const LANGS = [
  {
    value: 'en-GB',
    label: 'English',
    icon: <Image source={require("@assets/--native/Flags/great-britain-circular.svg")} style={{ width: 20, height: 20 }} />,
  },
  {
    value: 'fr',
    label: 'French',
    icon: <Image source={require("@assets/--native/Flags/france-circular.svg")} style={{ width: 20, height: 20 }} />,
  },
  {
    value: 'de',
    label: 'German',
    icon: <Image source={require("@assets/--native/Flags/germany-circular.svg")} style={{ width: 20, height: 20 }} />,
  },
  {
    value: 'es',
    label: 'Spanish',
    icon: <Image source={require("@assets/--native/Flags/spain-circular.svg")} style={{ width: 20, height: 20 }} />,
  },
  {
    value: 'it',
    label: 'Italian',
    icon: <Image source={require("@assets/--native/Flags/italy-circular.svg")} style={{ width: 20, height: 20 }} />,
  },
  {
    value: 'el',
    label: 'Greek',
    icon: <Image source={require("@assets/--native/Flags/greece-circular.svg")} style={{ width: 20, height: 20 }} />,
  },
  {
    value: 'ar',
    label: 'Arabic',
    icon: <Image source={require("@assets/--native/Flags/united-arab-emirates-circular.svg")} style={{ width: 20, height: 20 }} />,
  },
  {
    value: 'zh',
    label: 'Chinese',
    icon: <Image source={require("@assets/--native/Flags/china-circular.svg")} style={{ width: 20, height: 20 }} />,
  },
  {
    value: 'ja',
    label: 'Japanese',
    icon: <Image source={require("@assets/--native/Flags/japan-circular.svg")} style={{ width: 20, height: 20 }} />,
  },
  {
    value: 'tk',
    label: 'Turkish',
    icon: <Image source={require("@assets/--native/Flags/turkey-circular.svg")} style={{ width: 20, height: 20 }} />,
  },
  {
    value: 'si',
    label: 'Sinhala',
    icon: <SL/>
  },
  {
    value: 'ko',
    label: 'Korean',
    icon: <Image source={require("@assets/--native/Flags/south-korea-circular.svg")} style={{ width: 20, height: 20 }} />,
  },
  
];

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const [open, setOpen] = useState(null);
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const activeLanguage = useSelector((state: DefaultRootState) => state.app.language.value) || i18n.language;
  const theme = themeSelector();

  React.useEffect(() => {
    if (!activeLanguage) {
      const browserLanguage = navigator.language || navigator.language;
      const defaultLanguage = LANGS.find(lang => lang.value === browserLanguage) || LANGS[0];
      i18n.changeLanguage(defaultLanguage.value);
      dispatch({ type: CHANGE_LANGUAGE, payload: defaultLanguage.value });
    }
  }, [])

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          left: -2,
          ...(open && {
            bgcolor: 'action.selected',
          }),
        }}
      >
        <FlagHandler />
      </IconButton>
      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            ml: 0.75,
            width: 180,
          },
        }}
      >
        {LANGS.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === activeLanguage}
            onClick={() => { handleClose(); i18n.changeLanguage(option.value); dispatch({ type: CHANGE_LANGUAGE, payload: option.value }); }}
            sx={{ typography: 'body2', py: 1, backgroundColor: theme ? "white" : "#333333"}}
          >
            <View style={{ flex: 0.5 }}>
              {option.icon}
            </View>
            <View style={{ flex: 3 }}>
              <Text style={{ textAlign: "right", color: theme ? "black" : "white" }}>{option.label}</Text>
            </View>
          </MenuItem>
        ))}
      </Popover>
    </>
  );
}
